// Permissions were required to be sorted in a specific order
/* eslint-disable perfectionist/sort-enums */
export enum FlightRoomPermissions {
  VIEW = 'VIEW_FLIGHTROOMS',
  JOIN = 'JOIN_FLIGHTROOMS',
  REQUEST_ACCESS = 'REQUEST_ACCESS_FLIGHTROOMS',
  GRANT_ACCESS = 'GRANT_ACCESS_FLIGHTROOMS',
}
